/**
 * AdminChurchSitePage — admin backend for the Bishop Manjoro church CMS.
 * Reuses the same generic block editor as ABMHC; only the slug differs.
 */
import React from 'react';
import ABMHCSiteManager from '@/components/abmhc/ABMHCSiteManager';

const AdminChurchSitePage = () => (
  <div className="p-6 max-w-7xl mx-auto" data-testid="admin-church-site-page">
    <ABMHCSiteManager slug="bishop-manjoro" />
  </div>
);

export default AdminChurchSitePage;
